const SSO_TENANT_COOKIE = "sso_tenant_name";
const LEGACY_SIS_TENANTS = ["ihg", "ihgtraining"];
const SIS_AUTH_BASE = "https://sisstage.shijicloud.com/auth/realms";

function normalizeTenant(tenant) {
  return (tenant || "").trim();
}

function isLegacySisTenant(tenant) {
  const normalizedTenant = normalizeTenant(tenant).toLowerCase();
  return (
    !normalizedTenant || LEGACY_SIS_TENANTS.indexOf(normalizedTenant) !== -1
  );
}

function buildSisRedirectUri(identityAddress, returnUrl) {
  return encodeURIComponent(`${identityAddress}?ReturnUrl=${returnUrl}`);
}

function buildSisAuthUrl({ tenant, identityAddress, returnUrl }) {
  const redirectUri = buildSisRedirectUri(identityAddress, returnUrl);
  const normalizedTenant = normalizeTenant(tenant);

  if (isLegacySisTenant(tenant)) {
    return (
      `${SIS_AUTH_BASE}/shijiminiuat/protocol/openid-connect/auth?redirect_uri=` +
      redirectUri +
      "&client_id=shijimini&response_type=code&login=true&scope=openid&socialLogin=sep-pkce-oidc"
    );
  }
// + //&acr_values=auto-challenge-sso%20tenant:
    //encodeURIComponent(normalizedTenant)
  return (
    `${SIS_AUTH_BASE}/DL_shijimini/protocol/openid-connect/auth?redirect_uri=` +
    redirectUri +
    "&client_id=shijimini_kempinski&response_type=code&login=true&scope=openid&socialLogin=sep-pkce-oidc"
  );
}

function buildSisTokenParams({ code, redirectUri, ssoTenantName }) {
  const params = {
    code,
    redirect_uri: redirectUri,
  };
  const tenant = normalizeTenant(ssoTenantName);

  if (tenant) {
    params.sso_tenant_name = tenant;
  }

  return params;
}

module.exports = {
  SSO_TENANT_COOKIE,
  buildSisAuthUrl,
  buildSisRedirectUri,
  buildSisTokenParams,
  isLegacySisTenant,
  normalizeTenant,
};
